import Button from '@atoms/Button/Button';
import FormSelectorGroup from '@atoms/FormSelectorGroup/FormSelectorGroup';
import { IFormCheckboxGroup } from '@models/IFormCheckboxGroup';
import { useField } from 'formik';

const FormCheckboxGroup = ({
  name,
  checkboxClassName,
  checkboxLabelType,
  disableAllCtaLabel,
  dataTestId = 'Form-Checkbox-Group',
  ...rest
}: IFormCheckboxGroup) => {
  const [, , { setValue }] = useField<string[]>(name);

  return (
    <div>
      <FormSelectorGroup
        {...rest}
        name={name}
        selectorClassName={checkboxClassName}
        selectorLabelType={checkboxLabelType}
        type="checkbox"
        dataTestId={dataTestId}
      />

      {disableAllCtaLabel && (
        <Button
          className="mt-7.5"
          onClick={() => {
            setValue([]);
          }}
          secondary
          type="button"
          dataTestId={`${dataTestId}-Disable-All-Button`}
        >
          {disableAllCtaLabel}
        </Button>
      )}
    </div>
  );
};

export default FormCheckboxGroup;
